import "core-js/modules/es.array.push.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useRouter } from "vue-router";
import { isMobile } from "@/utils/libs";
export default {
  __name: 'PayReturn',
  setup(__props) {
    const router = useRouter();
    console.log(router.currentRoute.value.query);
    if (isMobile()) {
      router.push('/mobile/profile');
    } else {
      window.close();
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, " 支付回调 ");
    };
  }
};